<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase" icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-lead-pencil</v-icon>
                    </template>
                    <span>edit spot</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New parameters of the spot <span class="secondary--text">{{ spot.name }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row justify="center">
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="primary" label="spot's budget" v-model.number="budget"
                                    name="budget" type="text" prefix="$" hint="it's expected number" persistent-hint
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="9">
                                <v-select dense multiple color="secondary" label="channels" v-model="selected"
                                    :items="all_channels" item-color="secondary" :rules="[rules.required]"
                                    @input="checkChannel($event)" @change="onceMore()">
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row v-if="IsTargeted">	
							<v-col cols="12">Targeting parameters are available if at least one targeted channel is chosen</v-col>
							<hr />
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" label="min age" v-model.number="age_min" type="text"
									hint="it's expected number" persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore()">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-text-field dense color="secondary" label="max age" v-model.number="age_max" type="text"
									hint="it's expected number" persistent-hint
									:rules="[rules.required, rules.number]" @change="onceMore($event)">
								</v-text-field>
							</v-col>
							
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="dominant gender"
									v-model="gender" :items="DOMINANT_GENDER"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="income range"
									v-model="income" :items="INCOME_RANGE"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="education"
									v-model="education" :items="EDUCATION" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="civil status"
									v-model="status" :items="CIVIL_STATUS"
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="workplace"
									v-model="workplace" :items="WORKPLACE" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-select dense color="secondary" label="lifestyle"
									v-model="lifestyle" :items="LIFESTYLE" 
									item-color="secondary" :rules="[rules.required]" @change="onceMore()">
								</v-select>
							</v-col>
						</v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-center text-pre-wrap mx-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="!haveBeenChanged || Boolean(error)"
                    @click="recalculating">
                    Calculate
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" :disabled="!calculate || Boolean(error)"
                    @click="editSpot">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue';
import { CheckBudget, SpotCoverageCost } from '../../../functions/promotion.js'
export default {
    name: 'EditAdminSpot',
    props: ['spot'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            calculate: false,
            haveBeenChanged: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
            },

            //props
            channels: this.spot.channels,
            budget: this.spot.budget,
            coverage_general: 0,
            coverage_targeted: 0,
            age_min: this.spot.typical_age[0],
			age_max: this.spot.typical_age[1],
			gender: this.spot.gender,
			income: this.spot.income,
			education: this.spot.education,
			status: this.spot.civil_status,
			workplace: this.spot.job,
			lifestyle: this.spot.lifestyle,
			IsTargeted: false,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        /* game() {
            return this.$store.getters.game;
        }, */
        all_channels() {
            return this.$store.getters.CHANNELS;
        },
        media() {
            return this.$store.getters.media;
        },
        segments() {
            return this.$store.getters.market_segments;
        },
        marketSize() {
            let res = 0;
            if (this.segments.length > 0) {
                res = this.segments.reduce((sum, seg) => {
                    return sum+= seg.segment?.peak_size;
                }, 0)
            }
            return res;
        },
        selected: {
            get() {
                return this.channels;
            },
            set(val) {
                return this.channels = val;
            }
        },
        DOMINANT_GENDER () {
			return this.$store.getters.DOMINANT_GENDER;
		},
		INCOME_RANGE() {
            return this.$store.getters.INCOME_RANGE;
        },
        EDUCATION() {
            return this.$store.getters.EDUCATION;
        },
        CIVIL_STATUS() {
            return this.$store.getters.CIVIL_STATUS;
        },
        WORKPLACE() {
            return this.$store.getters.WORKPLACE;
        },
        LIFESTYLE() {
            return this.$store.getters.LIFESTYLE;
        },
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },
        onceMore() {
            this.error = ''
            this.calculate = false;
            this.message = '';
            this.haveBeenChanged = true;
        },
        checkChannel(event) {
			const arr = ['SMM', 'content ads', 'bloggers & influencers', 'banner ads'];
			for (let i=0; i < event.length; i++) {
				if (arr.includes(event[i])) {
					this.IsTargeted = true;
					return;
				}
			}
			this.IsTargeted = false;
		},
        recalculating() {
            /* console.log(this.channels) */
            if (this.$refs.form.validate()) {
            
                //check budget
                 const check_budget = CheckBudget(this.channels, this.media, this.budget);
                /*  console.log(check_budget);*/
                if (!check_budget) {
                    return this.error = `you don't have enough budget: ${this.budget}`;
                }

                /* chennels coverage */               
                [this.coverage_general, this.coverage_targeted] = SpotCoverageCost(this.channels, this.marketSize, this.media, check_budget);

                this.message = `Please, mention the figures:
					market coverage by general advertising = ${this.localeNumber(this.coverage_general)}
					market coverage by targeted advertising = ${this.localeNumber(this.coverage_targeted)} 
					_______________________________________
					if you agree, press the button Save`;
                this.calculate = true;
            }

        },
        async editSpot() {

            if (this.$refs.form.validate()) {

                const typical_age = [];
				
				if (this.age_min || this.age_max) {
					typical_age[0] = this.age_min;
					typical_age[1] = this.age_max;
				}
                const spot = {
                    id: Number(this.spot.id),
                    channels: this.channels,
                    budget: this.budget,
                    coverage_general: this.coverage_general, 
                    coverage_targeted: this.coverage_targeted,
                    typical_age: typical_age,
					gender: this.gender,
					income: this.income,
					education: this.education,
					civil_status: this.status,
					job: this.workplace,
					lifestyle: this.lifestyle,
                }
                /*console.log(spot);*/
                try {
                    //add spot 
                    await this.$store.dispatch('editTeamSpot', spot)
                    this.closeDialog()
                }
                catch (error) {
                    this.error = `Error: ${error.message}`;
                    this.message = '';
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.calculate = false;
            this.haveBeenChanged = false;
            this.channels = this.spot.channels;
            this.budget = this.spot.budget;
            this.coverage_general = 0;
            this.coverage_targeted = 0;
            this.age_min = this.spot.typical_age[0];
			this.age_max = this.spot.typical_age[1];
			this.gender = this.spot.gender;
			this.income = this.spot.income;
			this.education = this.spot.education;
			this.status = this.spot.civil_status;
			this.workplace = this.spot.job;
			this.lifestyle = this.spot.lifestyle;
			this.IsTargeted = false;

        }
    },
    components: { Loader },
    async mounted() {

        if (!this.media && this.spot) {
            try {
                await this.$store.dispatch('fetchMedia', {
                    gameId: this.spot.gameId, round: this.spot.round
                });
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.segments.length < 1) {
            const params = {
                gameId: this.spot.gameId,
                round: this.spot.round,
            }
            try {
                await this.$store.dispatch('fetchMarketSegments', params);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message);
            }
        }
        this.checkChannel(this.spot.channels);

    },
}

</script>
